// Dependencias generales
import React from "react";
import { useEffect } from 'react';

var dashboardCommonJS = require("../../js/dashboardCommon.js");

const InstallerInstallationWidget = (params) => {    

  useEffect(() => {                 
    console.log("Widget de detalle de instalación compartida con instalador cargado correctamente.")     
  
      if( (localStorage.getItem("deepLinkID") !== null) && (params.installationID === localStorage.getItem("deepLinkID")) ){  
        params.abrirCerrarWidget(localStorage.getItem("deepLinkID"))
        document.getElementById("details"+localStorage.getItem("deepLinkID")).setAttribute("open", "") 
        document.getElementById("search").value = document.getElementById("nombreInstalacion"+localStorage.getItem("deepLinkID")).innerHTML
        filtrarInstalaciones()
        localStorage.removeItem("deepLinkID")
      }    

  }, []);

  function filtrarInstalaciones(){
    var cadenaFiltrado = document.getElementById("search").value   
    var listadoInstalacionesBuscador = document.getElementById("listadoInstalacionesCompartidas").children
  
    var idElementoTemp = ""    
  
    for (var i = 0; i < listadoInstalacionesBuscador.length; i++) {
      
      idElementoTemp = listadoInstalacionesBuscador[i].id
      
      if( document.getElementById(idElementoTemp).getAttribute("searchdata").includes(cadenaFiltrado.toLowerCase())){
          document.getElementById(idElementoTemp).className = document.getElementById(idElementoTemp).className.replaceAll(" hidden", "")
      }
      else{
        document.getElementById(idElementoTemp).className += " hidden"
      }

    }    
  
  }

  return (      
    <div className="row">   
    
      <div id={"divTOTALES"+params.installationID} className="">

          <section id={"widgetTOTALES"+params.installationID} className="widget bubble widget-totales">

            <div id={"loaderInstalacion"+params.installationID} className="contextual">
              <progress aria-label="" style={{display: 'block', position: 'relative', margin: 'auto'}}></progress>
              <label style={{position: 'absolute', textAlign: 'center', marginTop: '100px'}}></label>      
            </div>

            <div id={"divWidgetTOTALES"+params.installationID} className="total-content">

              <div id={"widgetScoring"+params.installationID} className="scoring fill" >

                <div className="horizontal gap-04 fill start">

                  <div className="main-value ellipsis-container">
                    <figure id={"figureAhorroGasto"+params.installationID} className="avatar size-l"><span className="material-icon">euro</span></figure>
                    <dl className="vertical ellipsis-container">
                      <dt id={"literalAhorroGasto"+params.installationID} className="size-s">Gasto mes</dt>
                      <dd id={"scoringInstalacionAhorro"+params.installationID} className="headline-03">... %</dd>
                    </dl>
                  </div>

                  <div id={"widgetDashboardMonedero"+params.installationID} className="main-value fill right hidden">
                    <figure id={"figureMonederoBaterias"+params.installationID} className="avatar size-l gold " ><span id="iconoMonederoBaterias" className="material-icon gold">wallet</span></figure>
                    <dl className="vertical ellipsis-container">                                   
                      <dt id="literalMonederoBaterias" className="size-s">Monedero</dt>
                      <dd id={"scoringMonederoBaterias"+params.installationID} className="headline-03">...</dd>
                    </dl>
                  </div>

                  <div id={"widgetConsumoEnergia"+params.installationID} className="main-value fill right hidden">
                    <figure id={"figureAutoconsumo"+params.installationID} className="avatar size-l" ><span id={"iconoAutoconsumo"+params.installationID} className="material-icon">compost</span></figure>
                    <dl className="vertical ellipsis-container">
                      <dt id={"literalAutoconsumo"+params.installationID} className="size-s">...</dt>
                      <dd id={"scoringInstalacionEficiencia"+params.installationID} className="headline-03">... %</dd>
                    </dl>
                  </div>
                  
                </div>

                <div className="vertical gap-02">
                  <div className="horizontal gap-04 fill end">
                    <div className="main-value buy-price fill">
                      <dl className="vertical">
                        <dt id={"literalTarifaCompra"+params.installationID} className="size-s">Tarifa compra ahora</dt>
                        <dd id={"valorCompraAhoraDashboard"+params.installationID} className="headline-03"></dd>
                      </dl>
                    </div>
                    <div id="divValorVentaAhoraDashboard" className="main-value sale-price text-right fill ">
                      <dl className="vertical">
                        <dt id={"literalTarifaVenta"+params.installationID} className="size-s">Tarifa venta ahora</dt>
                        <dd id={"valorVentaAhoraDashboard"+params.installationID} className="headline-03"></dd>
                      </dl>
                    </div>
                  </div>
                </div>

                <dl id="lineaLinkAutoconsumo" className="horizontal self-consumption gap-02 fill hidden">
                  <dt  className="size-s">Autoconsumo mes:</dt>
                  <dd className="size-s horizontal gap-01">
                    <span id={"valorlineaLinkAutoconsumo"+params.installationID}></span>
                    <button className="link inline-link size-xs vertical-center" >
                      <span className="material-icon flip-right">expand_circle_down</span>
                    </button>
                  </dd>
                </dl>

              </div>                      


              <div className="overview" style={{paddingTop: "15px"}}>

                <div htmlFor="totalesInstalacion" className="additional-data ellipsis-container">
                  <dl className="vertical ellipsis-container">
                    <dt className="size-s">Consumo ahora</dt>
                    <dd id={"potenciaActual"+params.installationID}>... Wh</dd>
                  </dl>
                  <dl className="vertical text-right ellipsis-container">
                  <dt className="size-s">Máximo disponible</dt>
                      <dd id={"potenciaTOTALDisponible"+params.installationID}>... Wh</dd>
                  </dl>
                </div>

                <meter id={"resumenGeneralConsumoMeter"+params.installationID} min="0" max="0" value="0" className="fill"></meter>

                <dl className="horizontal ellipsis-container gap-02 vertical-center">                      
                  <dt id={"etiquetaConsumoMaximoHistorico"+params.installationID} className="size-s" >Consumo máximo histórico:</dt>
                  <dd className="horizontal gap-01">
                    <span id={"consumoMaximoHistoricoTotal"+params.installationID} className="size-s link no-pointer"></span>                                             
                  </dd>
                </dl>                

                <div id={"contenedorBotoneraInferiorDashboard"+params.installationID} className="main-data ellipsis-container">

                  <div id={"divTomandoDeLaRed"+params.installationID} className="main-value ellipsis-container hidden">                            
                    <dl className="vertical ellipsis-container">
                      <dt id={"etiquetaTomandoDeLaRed"+params.installationID} className="size-s"></dt>
                      <dd id={"tomandoDeLaRed"+params.installationID}>... Wh</dd>
                    </dl>
                    <div className="generators-list">
                      <figure id={"figureTomandoDeLaRed"+params.installationID} className="avatar green" >
                        <span id={"spanFigureTomandoDeLaRed"+params.installationID} className="material-icon"></span>
                      </figure>
                    </div>
                  </div>

                  <div id={"divGenerando"+params.installationID} className="main-value ellipsis-container">                            
                    <dl className="vertical ellipsis-container">
                      <dt className="size-s">Generando</dt>
                      <dd id={"generacionTOTALActual"+params.installationID}>... Wh</dd>
                    </dl>
                    <div className="generators-list">
                      <figure id={"figureFVGenerando"+params.installationID} className="avatar disabled hidden">
                        <span className="material-icon">solar_power</span>
                      </figure>
                      <figure id={"figureBateriasGenerando"+params.installationID} className="avatar disabled percentage-indicator hidden">
                        <span className="material-icon">battery_std</span>   
                        <span id={"etiquetaPorcentajeBateriasGenerando"+params.installationID} className="indicator"></span>
                      </figure>
                      <figure id={"figureGrupoGenerando"+params.installationID} className="avatar disabled percentage-indicator hidden">
                        <span className="material-icon">dynamic_form</span>
                        <span id={"etiquetaPorcentajeGrupoGenerando"+params.installationID} className="indicator"></span>
                      </figure>
                    </div>
                  </div>

                  <div id={"divConsumiendo"+params.installationID} className="main-value ellipsis-container">                            
                    <dl className="vertical ellipsis-container">
                      <dt className="size-s">Consumiendo</dt>
                      <dd id={"consumoTOTALActual"+params.installationID}>... Wh</dd>
                    </dl>
                    <div className="generators-list">
                      <figure id={"figureInstalacionConsumiendo"+params.installationID} className="avatar disabled hidden">
                        <span className="material-icon">{dashboardCommonJS.obtenerIconoInstalacion(params.tipoInstalacion)}</span>
                      </figure>
                      <figure id={"figureBateriasConsumiendo"+params.installationID} className="avatar disabled percentage-indicator hidden">
                        <span className="material-icon">battery_std</span>
                        <span id={"etiquetaPorcentajeBateriasConsumiendo"+params.installationID} className="indicator"></span>
                      </figure>
                      <figure id={"figureCocheConsumiendo"+params.installationID} className="avatar disabled percentage-indicator hidden">
                        <span className="material-icon">directions_car</span>
                        <span id={"etiquetaPorcentajeCocheConsumiendo"+params.installationID} className="indicator"></span>
                      </figure>                              
                    </div>
                  </div>


                  <div id={"divDevolviendoARed"+params.installationID} className="main-value ellipsis-container hidden">                            
                    <dl className="vertical ellipsis-container">
                      <dt id={"etiquetaDevolviendoARed"+params.installationID} className="size-s">...</dt>
                      <dd id={"devolviendoARed"+params.installationID}>... Wh</dd>
                    </dl>
                    <div className="generators-list">
                      <figure id={"figureDevolviendoARed"+params.installationID} className="avatar green" >
                        <span id={"spanFigureDevolviendoARed"+params.installationID} className="material-icon"></span>
                      </figure>
                    </div>
                  </div>

                  <span id={"statusConexionRed"+params.installationID} className=" hidden"></span>

                </div>

                <button id={"linkAhorroTarifasDashboard"+params.installationID} href="#" className="message small success left no-pointer hidden ">
                  <div className="horizontal vertical-center">
                    <span id="iconoFuentesAlternativasEnergia" className="material-icon">query_stats</span>                              
                    <span id={"literalAhorroTarifaDashboard"+params.installationID} className="fill size-s"></span>                    
                  </div>
                </button>

              </div>

            </div>

          </section>

      </div>

    </div>
    )
  }

export default InstallerInstallationWidget